module.exports = __webpack_public_path__ + "static/media/certificate-path.a0e788cc.svg";